<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name(v-if="keyName" :class="{ 'non-active-font': !active }") {{ keyName }}
      slot(name="keyName")
      span.validation-label(v-if="required == true") 必須
      span.option-text.font-strong-color {{ optionText }}

    .register-value
      .position-relative
        input.register-form(v-model="_value" :name="name" :type="type" :placeholder="placeholder" v-validate="validationRules"
          :maxlength="maxlength" :data-vv-as="(validationKeyName) ? validationKeyName : keyName" :style="styles"
          :class="[ { noinput: (required == true && !_value) }, { 'non-active': !active } ]" :disabled="!active")
        .show-password-icon.position-absolute.translate-middle.toggle-type(v-if="type == 'password'" @click="toggleType") 表示
        .hide-password-icon.position-absolute.translate-middle.toggle-type(v-if="type == 'text'" @click="toggleType") 非表示

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br

    slot(name="default")

</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * 入力要素コンポーネント
 *
 * - 単一の入力をサポートする
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputPassword extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: string;

  /** 項目名 */
  @Prop({ type: String })
  keyName!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  required!: boolean;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** input要素のプレースホルダー */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  placeholder!: string;

  /** 最大長 */
  @Prop({ type: Number })
  maxlength!: number;

  /** veevalidateに渡すバリデーションルール */
  @Prop()
  validationRules!: string;

  /** veevalidateに渡すバリデーション項目名 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  validationKeyName!: string;

  /** スタイル(主にサイズ指定) */
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  styles!: any;

  /** 説明文 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  optionText!: string;

  /** 活性化/非活性化 */
  @Prop({
    default: () => {
      return true;
    }
  })
  active!: boolean;

  type: string = "password";

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): string {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: string) {
    this.$emit("input", newValue);
    return;
  }

  toggleType(): void {
    if (this.type == "password") {
      this.type = "text";
    } else {
      this.type = "password";
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.show-password-icon {
  @include svg-icon("../../../assets/show-password.svg", $font-base-color, 24px, 24px);
}
.hide-password-icon {
  @include svg-icon("../../../assets/hide-password.svg", $font-base-color, 24px, 24px);
}
.toggle-type {
  transform: translate(-50%, -50%) !important;
  top: 50% !important;
  right: 0 !important;
  width: 20px;
  height: 16px;
  text-align: center;
}
.register-form {
  max-width: 600px;
  width: 600px;
}
.option-text {
  margin-left: 8px;
}
.non-active-font {
  color: $form-border-color;
}
.non-active {
  cursor: not-allowed;
  color: $form-border-color;
  background-color: $bg-gray !important;
}
</style>
